import { render } from "./ZaikoMoveDetailPage.vue?vue&type=template&id=65696798"
import script from "./ZaikoMoveDetailPage.vue?vue&type=script&lang=js"
export * from "./ZaikoMoveDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\hirayama.yuichi\\Nextcloud\\_hy\\EdgeStudio\\20260701_JCI\\20260717_試着室の対応\\納品物_Ver03\\成果物\\03_ソース\\04_ダッシュボード関連\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__